module.exports = "/_next/static/images/ux-design-awards-gold-2021-538f7e7bf4039a77ef8c570dc3806cd0.png.webp";